import { Page } from '../models/Elements';
import { GrowingDegreeDay } from '../models/Entities';
import dateService from '../services/DateService';
import { coreApiAxios } from './CustomAxios';
import { PhaseType, PlagueType } from '../models/Types';

class GrowingDegreeDayApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        aemetWeatherStationId?: string,
        plague?: PlagueType,
        generation?: number,
        phase?: PhaseType,
        searchText?: string
    ): Promise<Page<GrowingDegreeDay>> => {
        const response = await coreApiAxios.get<Page<GrowingDegreeDay>>('/growing-degree-days', {
            params: { page, size, sortField, sortOrder, aemetWeatherStationId, plague, generation, phase, searchText }
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((growingDegreeDay) => this.loadDates(growingDegreeDay));

        return response.data;
    };

    get = async (id: number): Promise<GrowingDegreeDay> => {
        const response = await coreApiAxios.get<GrowingDegreeDay>(`/growing-degree-days/${id}`);
        this.loadDates(response.data);

        return response.data;
    };

    create = async (growingDegreeDay: GrowingDegreeDay): Promise<GrowingDegreeDay> => {
        const response = await coreApiAxios.post<GrowingDegreeDay>(`/growing-degree-days`, growingDegreeDay);
        this.loadDates(response.data);

        return response.data;
    };

    update = async (growingDegreeDay: GrowingDegreeDay): Promise<GrowingDegreeDay> => {
        const response = await coreApiAxios.put<GrowingDegreeDay>(`/growing-degree-days/${growingDegreeDay.id}`, growingDegreeDay);
        this.loadDates(response.data);

        return response.data;
    };

    delete = async (id: number): Promise<void> => {
        const response = await coreApiAxios.delete<void>(`/growing-degree-days/${id}`);

        return response.data;
    };
    /**
     * Loads the dates of a growing degree day.
     * @param growingDegreeDay - the growing degree day
     */
    private loadDates(growingDegreeDay: GrowingDegreeDay) {
        growingDegreeDay.measurementDate = dateService.transformDate(growingDegreeDay.measurementDate)!;
        growingDegreeDay.audit!.created = dateService.transformDate(growingDegreeDay.audit!.created)!;
        growingDegreeDay.audit!.updated = dateService.transformDate(growingDegreeDay.audit!.updated)!;
    }
}

const growingDegreeDayApi: GrowingDegreeDayApi = new GrowingDegreeDayApi();
export default growingDegreeDayApi;
